import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './home.css';
import './booking.css';
import './../animations.css';
import star from '../assets/star.svg';
import hand from '../assets/logo2.svg';

import frame2 from '../assets/frame23.svg';

import HeadingBlock from '../components/common/heading';
import FatimaHand from '../components/common/fatimahand';

const Login = () => {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({ username: '', password: '' });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.username.trim()) newErrors.username = 'Username is required.';
    if (!formData.password.trim()) newErrors.password = 'Password is required.';

    if (formData.username && formData.password) {
      if (formData.username !== 'admin' || formData.password !== '1234') {
        newErrors.password = '❌ Invalid username or password.';
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    navigate('/home');
  };

  return (
    <main className='fixedWidth'>
      <div className="secBg secBg2 scalein2"><img alt="" src={frame2} /></div>

      <div className="secContainer formSec fixedWidth">
        <section className="section1">
          <div className="heroCont1 eventSec1 formCont">
<img className='formIcon' src={hand} alt="" />
            {/* <FatimaHand /> */}
            <HeadingBlock heading="Login " subheading="Welcome back! Please enter your details." style1="dark left decor wrapped padded2" />
            <form className="fadeIn" onSubmit={handleSubmit} noValidate>
              <div className="doubleInputs">

                <div className="inputFlex">
                  <label htmlFor="username">Username</label>
                  <div className={`inputCont ${errors.username ? 'inputError' : ''}`}>
                    <input
                      id="username"
                      name="username"
                      type="text"
                      value={formData.username}
                      onChange={handleChange}
                      placeholder="Enter your username"
                    />
                  </div>
                  {errors.username && <span className="fieldError" role="alert">{errors.username}</span>}
                </div>

                <div className="inputFlex">
                  <label htmlFor="password">Password</label>
                  <div className={`inputCont ${errors.password ? 'inputError' : ''}`}>
                    <input
                      id="password"
                      name="password"
                      type="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Enter your password"
                    />
                  </div>
                  {errors.password && <span className="fieldError" role="alert">{errors.password}</span>}
                </div>
              </div>
              <button type="submit" className="blue size2">
                <img src={star} alt="" />
                <h6>Login</h6>
                <img src={star} alt="" />
              </button>
                <h3>Don't Have an Account? <a href="/">Sign Up</a></h3>
            </form>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Login;